function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions as cmsActions } from '../../../reducers/cms.reducer';
import useHasPermission from '../../../helpers/hooks/useHasPermission';
import Card from '../card/Card.react';
import CardHeader from '../card/CardHeader.react';
import CardBody from '../card/CardBody.react';
import Label from '../form/Label.react';
import Input from '../form/Input.react';
import Textarea from '../form/Textarea.react';
import Button from '../Button.react';
var SEO = function SEO(_ref) {
  var _siteSettings$app;
  var header = _ref.header,
    metadata = _ref.metadata,
    archived = _ref.archived,
    type = _ref.type,
    itemID = _ref.itemID,
    _ref$permission = _ref.permission,
    permission = _ref$permission === void 0 ? null : _ref$permission;
  var _useParams = useParams(),
    app = _useParams.app;
  var hasPermission = useHasPermission(permission);
  var dispatch = useDispatch();
  var siteSettings = useSelector(function (s) {
    return s.cms.siteSettings;
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var metaDataID = state._id,
    title = state.title,
    description = state.description,
    keywords = state.keywords,
    tags = state.tags;
  useEffect(function () {
    setState(metadata);
  }, [metadata]);
  var defaultMetaData = siteSettings ? (_siteSettings$app = siteSettings[app]) === null || _siteSettings$app === void 0 ? void 0 : _siteSettings$app.metadata : {};
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: header || 'SEO Data'
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Title"
  }), /*#__PURE__*/React.createElement(Input, {
    value: title || '',
    placeholder: "Default: ".concat(defaultMetaData === null || defaultMetaData === void 0 ? void 0 : defaultMetaData.title),
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        title: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Description"
  }), /*#__PURE__*/React.createElement(Textarea, {
    value: description || '',
    placeholder: "Default: ".concat(defaultMetaData === null || defaultMetaData === void 0 ? void 0 : defaultMetaData.description),
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        description: e.target.value
      }));
    },
    style: {
      height: 120
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Keywords"
  }), /*#__PURE__*/React.createElement(Textarea, {
    value: keywords,
    placeholder: "Default: ".concat(defaultMetaData === null || defaultMetaData === void 0 ? void 0 : defaultMetaData.keywords),
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        keywords: e.target.value
      }));
    },
    style: {
      height: 120
    }
  }), !archived && hasPermission && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Save",
    apiID: "save-seo",
    onClick: function onClick() {
      dispatch({
        type: cmsActions.seo,
        payload: {
          formData: {
            title: title,
            description: description,
            keywords: keywords,
            tags: tags,
            metaDataID: metaDataID,
            type: type,
            itemID: itemID,
            apiID: 'save-seo'
          },
          method: metaDataID ? 'put' : 'post'
        }
      });
    }
  })))));
};
export default SEO;